{
  "users": {
    "title": "Users Management",
    "add": "Add User",
    "columns": {
      "name": "Name",
      "username": "Username",
      "email": "Email",
      "group": "Group",
      "branches": "Branches",
      "status": "Status",
      "lastLogin": "Last Login"
    },
    "neverLoggedIn": "Never logged in",
    "filters": {
      "status": "Status",
      "group": "Group"
    },
    "rowActions": {
      "trigger": "Actions for {{name}}"
    },
    "drawer": {
      "createTitle": "Add User",
      "editTitle": "Edit User",
      "createDescription": "Search for an existing employee by username, or create a new one.",
      "editDescription": "Update this user's information.",
      "usernameSearch": "Search by username",
      "usernameSearchPlaceholder": "Employee username",
      "search": "Search",
      "foundEmployee": "Existing employee found",
      "useNewEmployee": "Create a new employee instead",
      "fields": {
        "nameAr": "Arabic Name",
        "nameEn": "English Name",
        "username": "Username",
        "email": "Email",
        "phone": "Phone",
        "nfcId": "NFC ID",
        "group": "Group",
        "branches": "Branches"
      },
      "created": "User created successfully",
      "updated": "User updated successfully"
    },
    "resetPassword": {
      "title": "Reset Password",
      "emailedDescription": "A password reset link has been sent to this user's email.",
      "linkDescription": "This user has no email on file. Share this one-time link with them directly:",
      "close": "Close"
    },
    "setupLink": {
      "title": "Setup Link",
      "emailedDescription": "A setup link has been sent by email.",
      "linkDescription": "This user has no email on file. Share this one-time link with them directly:",
      "close": "Close"
    },
    "statusConfirmTitle": "Change this user's status?",
    "deleteConfirmTitle": "Delete this user?",
    "deleteConfirmDescription": "{{name}} will lose access to Customer Registry. Their shared employee account is not affected.",
    "resetPasswordConfirmTitle": "Reset this user's password?",
    "resetPasswordConfirmDescription": "{{name}} will need to set a new password to sign in again.",
    "deleted": "User deleted successfully",
    "statusChanged": "User status changed successfully",
    "passwordReset": "Password reset successfully"
  },
  "groups": {
    "title": "Groups Management",
    "add": "Add Group",
    "columns": {
      "name": "Name",
      "description": "Description",
      "users": "Users",
      "services": "Services",
      "status": "Status"
    },
    "rowActions": {
      "trigger": "Actions for {{name}}",
      "assignServices": "Assign Services"
    },
    "drawer": {
      "createTitle": "Add Group",
      "editTitle": "Edit Group",
      "createDescription": "Create a group to assign users their services.",
      "editDescription": "Update this group's information.",
      "fields": {
        "nameAr": "Arabic Name",
        "nameEn": "English Name",
        "descriptionAr": "Arabic Description",
        "descriptionEn": "English Description"
      },
      "created": "Group created successfully",
      "updated": "Group updated successfully"
    },
    "statusConfirmTitle": "Change this group's status?",
    "deleteConfirmTitle": "Delete this group?",
    "deleteConfirmDescription": "{{name}} will be permanently removed. This cannot be undone.",
    "systemGroupProtected": "The built-in system group cannot be changed",
    "deleted": "Group deleted successfully",
    "statusChanged": "Group status changed successfully"
  },
  "services": {
    "title": "Assign Services",
    "description": "Choose the services this group's users can perform.",
    "selectAll": "Select All",
    "deselectAll": "Deselect All",
    "search": "Search services",
    "save": "Save",
    "saved": "Permissions saved successfully",
    "discardTitle": "Discard changes?",
    "discardDescription": "Your unsaved service changes will be lost.",
    "unsavedChanges": "You have unsaved changes"
  },
  "customerSettings": {
    "title": "Customers settings",
    "phoneVerification": "Verify the phone number with a WhatsApp code",
    "phoneVerificationHelp": "A code is sent by WhatsApp when a customer is added or a phone is changed. The record is saved only after the code is entered.",
    "saved": "Customers settings updated successfully"
  }
}
